import { Injectable } from '@angular/core';
import { _ } from 'underscore';

@Injectable()
export class HelperService {


  constructor() { }

  public RemoveItemFromArray(array, item, predicate) {
    var itemToRemove = this.Find(array, predicate);
    if (itemToRemove) {
      let returnedArray = _.without(array, itemToRemove);
      return returnedArray;
    }
    array;
  }

  public AddItemToArray(array, item) {
    let returnedArray = _.union(array, item);
    return returnedArray;
  }

  public Exists(array, predicate): boolean {
    return _.findIndex(array, predicate)>=0;
  }

  public Find(array, predicate): any {
    return _.find(array, predicate);
  }


  Without<T>(list: T[], predicate): T[] {
   return _.reject(list, predicate);
  }

}
